import { render } from "./BackerCenterPaymentsCard.vue?vue&type=template&id=a1274ec2"
import script from "./BackerCenterPaymentsCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__